import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Driver } from '@commons/models/domain/Driver';
import { driverLicenseToText } from '@src/app/utils/workers/driver-license-status';

@Pipe({
  name: 'driverStatusToText',
  standalone: true
})
export class DriverStatusToTextPipe implements PipeTransform {

  transform(data: Driver, translateService: TranslateService): string {
    return driverLicenseToText(data, translateService);
  }

}
